import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SurveysPage } from '@apps/web/components/surveys/surveys_page';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';

const surveysSearchSchema = z.object({
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/surveys/')({
    head: () => ({
        meta: [{ title: 'Surveys | Phoebe' }],
    }),
    validateSearch: surveysSearchSchema,
    component: SurveysRoute,
});

function SurveysRoute() {
    const { organizationId, mode } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        organizationId,
        mode,
    );
    return isWaitingForDeepLinkOrganization ? null : <SurveysPage />;
}
